/**
 * @Author:      jiang.weiwei
 * @DateTime:    2017-12-20 17:47:50
 * @Description: 轮播图
 */

'use strict';
angular.module("carouselFigureModule", [])
    .directive('carouselFigure', [function() {
        return {
            scope: true,
            restrict: 'AE',
            templateUrl: './login/trsCarouselFigure/carouselFigure_tpl.html',
            replace: true,
            link: function(scope, iElm, iAttrs, controller) {
                initStatus();

                function initStatus() {
                    var windowH = document.body.clientHeight;
                    $(iElm).find('div').css('height', windowH);
                    $(window).resize(function() {
                        var windowH = document.body.clientHeight;
                        $(iElm).find('div').css('height', windowH);
                    });
                    // var aBtn = $(iElm).find('li');
                    // var aPic = $(iElm).find('div');
                    // var len = aBtn.length;
                    // var index = 0;
                    // var adTimer;

                    // aBtn.on('mouseover', function() {
                    //     clearInterval(adTimer);
                    //     var index = $(this).index();
                    //     showImg(index);
                    // });
                    // adTimer = setInterval(function() {
                    //     showImg(index)
                    //     index++;
                    //     if (index == len) { //最后一张图片之后，转到第一张
                    //         index = 0;
                    //     }
                    // }, 3000);
                    // scope.$on("$destroy", function() {
                    //     clearInterval(adTimer);
                    // });

                    // function showImg(index) {
                    //     $(aBtn).removeClass('active');
                    //     $(aBtn[index]).addClass('active');
                    //     $(aPic).css('display', 'none');
                    //     $(aPic[index]).css('display', 'block');
                    // }

                }
            }
        };
    }]);
